import React from "react";

export const Spinner = ({ position, type }) => {
  return (
    <div className={`text-${position ? position : "center"}`}>
      <div className={`spinner-${type ? type : "border"}`} role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};
